
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rechtliches/[slug]",
      function () {
        return require("private-next-pages/rechtliches/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rechtliches/[slug]"])
      });
    }
  